import { render, staticRenderFns } from "./ranking-item.vue?vue&type=template&id=4e12bf34&scoped=true"
import script from "./ranking-item.vue?vue&type=script&lang=js"
export * from "./ranking-item.vue?vue&type=script&lang=js"
import style0 from "./ranking-item.vue?vue&type=style&index=0&id=4e12bf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e12bf34",
  null
  
)

export default component.exports